export default __webpack_public_path__ + "static/media/US_Hero1_2.a0ae61ca.png";